import { AutogenLayoutFuelInterfaceLookup } from "./autogen/AutogenLayoutFuelInterfaceLookup";

export class FuelInterfaceLookup extends AutogenLayoutFuelInterfaceLookup {
    
}
